import { render, staticRenderFns } from "./MicroTest.vue?vue&type=template&id=ac21cf16&scoped=true&"
import script from "./MicroTest.vue?vue&type=script&lang=js&"
export * from "./MicroTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac21cf16",
  null
  
)

export default component.exports